import { useOutletContext } from "react-router-dom";
import { useState, useEffect } from "react";
import { useApi } from "@/lib/useApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const regimi = ["Ordinario", "Semplificato", "Forfettario", "Agricoltura", "Altro"];

export default function ResellerProfile() {
  const me = useOutletContext();
  const api = useApi();
  const qc = useQueryClient();
  const existing = me?.reseller;
  const [form, setForm] = useState({
    anagrafica: existing?.anagrafica || { nome: "", cognome: "", email: me?.user?.email || "", telefono: "" },
    company: existing?.company || { ragione_sociale: "", piva: "", codice_fiscale: "", regime_fiscale: "Ordinario", iban: "", sede: "" },
  });

  useEffect(() => {
    if (existing) {
      setForm({ anagrafica: existing.anagrafica, company: existing.company });
    }
  }, [existing?.id]);

  const save = useMutation({
    mutationFn: async () => (await api.post("/reseller/profile", form)).data,
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["me"] }); toast.success("Anagrafica salvata — in attesa di approvazione dei documenti"); },
    onError: (e) => toast.error(e.response?.data?.detail || "Errore"),
  });

  const setAnag = (k, v) => setForm({ ...form, anagrafica: { ...form.anagrafica, [k]: v } });
  const setComp = (k, v) => setForm({ ...form, company: { ...form.company, [k]: v } });

  return (
    <div className="space-y-5 max-w-4xl">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Anagrafica rivenditore</h1>
        <p className="text-sm text-slate-500 mt-1">Dati fiscali e di contatto. Dopo il salvataggio dovrà caricare i documenti e l'accordo firmato nella sezione Documenti.</p>
      </div>

      <div className="bg-white border border-[#E2DDD5] rounded-xl p-5 space-y-4">
        <div className="font-semibold">Dati personali</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div><Label>Nome</Label><Input value={form.anagrafica.nome} onChange={(e) => setAnag("nome", e.target.value)} data-testid="an-nome" /></div>
          <div><Label>Cognome</Label><Input value={form.anagrafica.cognome} onChange={(e) => setAnag("cognome", e.target.value)} data-testid="an-cognome" /></div>
          <div><Label>Email</Label><Input value={form.anagrafica.email} onChange={(e) => setAnag("email", e.target.value)} data-testid="an-email" /></div>
          <div><Label>Telefono</Label><Input value={form.anagrafica.telefono} onChange={(e) => setAnag("telefono", e.target.value)} data-testid="an-telefono" /></div>
        </div>
      </div>

      <div className="bg-white border border-[#E2DDD5] rounded-xl p-5 space-y-4">
        <div className="font-semibold">Dati aziendali e contabili</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div><Label>Ragione sociale</Label><Input value={form.company.ragione_sociale} onChange={(e) => setComp("ragione_sociale", e.target.value)} data-testid="an-rag" /></div>
          <div><Label>P. IVA</Label><Input value={form.company.piva} onChange={(e) => setComp("piva", e.target.value)} data-testid="an-piva" /></div>
          <div><Label>Codice Fiscale</Label><Input value={form.company.codice_fiscale} onChange={(e) => setComp("codice_fiscale", e.target.value)} data-testid="an-cf" /></div>
          <div>
            <Label>Regime fiscale</Label>
            <select value={form.company.regime_fiscale} onChange={(e) => setComp("regime_fiscale", e.target.value)} className="w-full h-10 px-3 border border-[#E2DDD5] rounded-md bg-white" data-testid="an-regime">
              {regimi.map((r) => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>
          <div className="md:col-span-2"><Label>IBAN</Label><Input value={form.company.iban} onChange={(e) => setComp("iban", e.target.value)} data-testid="an-iban" /></div>
          <div className="md:col-span-2"><Label>Sede legale</Label><Input value={form.company.sede} onChange={(e) => setComp("sede", e.target.value)} data-testid="an-sede" /></div>
        </div>
      </div>

      <Button onClick={() => save.mutate()} className="bg-[#B84A2B] hover:bg-[#983C21] text-white" data-testid="btn-save-profile">Salva anagrafica</Button>
    </div>
  );
}
